// Module
var code = "<h3>Navigation</h3> <div class=\"card\"> <h5>User Navigation</h5> <hr class=\"mb-8\"/> <div id=\"navListDiv\" class=\"w-full\"></div> <div id=\"allocNavListDiv\"></div> </div> ";
// Exports
export default code;